
import { formatUSD } from '@/shared/utils/ultils';
import leftthitruong from '../../../../assets/img/left-thitruong.gif'
import rightthitruong from '../../../../assets/img/right-thitruong.gif'
import { useEffect, useState } from 'react';
import { socket } from '@/shared/config/socket';

const ThiTruong = ({config, setIdMarket} : any) => {
    const [listHangHoa, setListHangHoa] = useState<any>([]);
    useEffect(() => {
        socket.on('get_prices', (data: any) => {
            setListHangHoa(data)
        })
    }, [])

    return <div className="mt-4 h-100" style={{ background: "hsl(223 64% 8%)", borderRadius: 5 }}>
        <div className="d-flex p-3 align-items-center gap-1" style={{ borderBottom: "1px solid hsl(0deg 0% 100% / 10%)" }}>
        <div className="text-center"><img src={leftthitruong} height={40} /></div>
        <div className="w-100 text-center chunhapnhay" style={{ color: "#00f42e", fontSize: 16, fontWeight: "bold" }}>Thị trường hàng hoá</div>
        <div className="text-center"><img src={rightthitruong} height={40} /></div>
    </div>
    {
        listHangHoa?.map( (item: any, index: number) => {
            return <div className="d-flex p-3 cursor-pointer" key={index} style={{ borderBottom: "1px solid hsl(0deg 0% 100% / 10%)"}} onClick={() => setIdMarket(item?.id)}>
                    <div className="w-100 d-flex gap-2 text-center">
                        <img className="rounded-circle" width={25} src={`https://faofood.com/assets/images/commodity/` + item?.image} />
                        {item?.name}</div>
                    <div className="w-100 text-center">{formatUSD(item?.price)}</div>
                    <div className="w-100 d-flex gap-1 align-items-center justify-content-end">{item?.twenty_four_hour_change}%
                        {item?.twenty_four_hour_change > 0 ? <i style={{  color: "hsl(152 69% 31%)" }} className="fa-solid fa-arrow-trend-up"></i> :  <i style={{ color: "hsl(354 70% 54%)" }} className="fa-solid fa-arrow-trend-down"></i> }
                    </div>
                </div>
        })
    }
</div>
}

export default ThiTruong